<template>
  <div class="animated fadeIn apagar-cadastro-page">
    <HeaderPadrao
      :titulo="registro.SEQUENCIA > 0 ? `Contas a Pagar - ${registro.DOCUMENTO}` : 'CONTAS A PAGAR'"
      :icon="registro.SEQUENCIA > 0 ? 'fa fa-suitcase' : 'fa fa-plus-circle'"
    >
      <template #subtitulo>
        <div v-if="registro.SEQUENCIA > 0" class="d-flex align-items-center flex-wrap">
          <span class="badge-light-opacity mr-2">CÓDIGO: {{ registro.SEQUENCIA }}</span>
          <span class="mr-2">•</span>
          <span>Descrição: {{ registro.ITENS || 'Sem descrição' }}</span>
        </div>
        <span v-else>Cadastro de Compromissos Financeiros</span>
      </template>
      <template #acoes>
        <b-button v-if="formok" variant="success" class="btn-glass mr-2" @click="post()">
          <i class="fa fa-save mr-1"></i> Gravar F10
        </b-button>
        <b-button variant="light" pill class="font-weight-bold shadow-sm" @click="voltar()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="px-3">
      <!-- Barra de Resumo Premium -->
      <div class="row summary-grid mb-4 mt-2">
        <div class="col-md-3">
          <div class="summary-card bg-gradient-primary shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-file-text-o"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Valor do Título</span>
                <h3 class="summary-value">R$ {{ (registro.VL_DOC || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="summary-card bg-gradient-warning shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-clock-o"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Valor em Aberto</span>
                <h3 class="summary-value">R$ {{ (registro.VL_APAGAR || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="summary-card bg-gradient-success shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-calendar-check-o"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Vencimento</span>
                <h3 class="summary-value">{{ converterDataVencimento(registro.DT_VENC) || '--/--/----' }}</h3>
                <small :class="['d-block mt-1 font-weight-bold', diasParaVencerClass]">{{ diasParaVencer }}</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="summary-card shadow-sm" :class="statusCardClass">
            <div class="summary-body">
              <div class="summary-icon-wrapper" :class="statusIconClass">
                <i class="fa" :class="statusIcon"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Status</span>
                <h3 class="summary-value">
                  <span :class="['status-chip', statusClass]">{{ registro.STATUS || 'PENDENTE' }}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cadastro-scroll pr-2">

        <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
          <div class="card-header bg-white border-bottom-0 py-3">
            <h5 class="mb-0 text-primary font-weight-bold">
              <i class="fa fa-info-circle mr-2"></i>Dados Principais
            </h5>
          </div>
          <b-card-body class="pt-0">
            <div class="row">
              <div class="col-sm-2">
                <b-form-group label="Código" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="ID" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" placeholder="Automático" v-model="registro.SEQUENCIA"></b-form-input>
                </b-form-group>
              </div>
              
              <div class="col-sm-2">
                <b-form-group label="Documento" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="edDOCUMENTO" class="rounded-pill shadow-xs" v-model="registro.DOCUMENTO" :disabled="desabilitado" :state="!!registro.DOCUMENTO" placeholder="N. Documento" maxlength="10"></b-form-input>
                </b-form-group>
              </div>

              <div v-if="registro.SEQUENCIA > 0" class="col-sm-2">
                <b-form-group label="Parcela" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="edPARCELA" class="rounded-pill bg-light border-0 shadow-xs" v-model="registro.PARCELAS" disabled placeholder="N. Parcela" maxlength="10"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm-2">
                <b-form-group label="N. Externo" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="edNUMERO_EXTERNO" class="rounded-pill shadow-xs" v-model="registro.NUMERO_EXTERNO" placeholder="N. Externo" maxlength="40" :state="!!registro.NUMERO_EXTERNO"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm-4">
                <b-form-group label="Tipo de documento" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-select :plain="true" class="rounded-pill custom-select shadow-xs" v-model="registro.OP_TIPO" :state="!!registro.OP_TIPO" :options="tipoOptions"></b-form-select>
                </b-form-group>
              </div>
            </div>  
            
            <div class="row">
              <div class="col-sm-6">
                <b-form-group label="Descrição para o Relatório" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="edITENS" class="rounded-pill shadow-xs" v-model="registro.ITENS" placeholder="Descrição min (3 letras)" :state="!!registro.ITENS" maxlength="500"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-3">
                <b-form-group label="Data do Documento" label-class="font-weight-bold text-muted small text-uppercase">
                    <b-form-input type="date" id="ob_dtDocumento" class="rounded-pill shadow-xs" v-model="registro.DT_DOC" :disabled="desabilitado" :state="!!registro.DT_DOC"></b-form-input>
                </b-form-group>
              </div>
              <div v-if="registro.SEQUENCIA > 0" class="col-sm-3">
                <b-form-group label="Data do Vencimento" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="date" id="ed_dtVencimento" class="rounded-pill shadow-xs" v-model="registro.DT_VENC" :state="!!registro.DT_VENC"></b-form-input>
                </b-form-group>
              </div>
            </div>
          </b-card-body>
        </b-card>

        <b-row>
          <b-col sm="12">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-users mr-2"></i>Interessados
                </h5>
              </div>
              <b-card-body class="pt-0">
                <div class="row">
                  <div class="col-sm-6 mb-3">
                    <cliente-pesquisa 
                      @retornaId="registro.COD_FORNEC = $event"
                      :idInicial="registro.COD_FORNEC"
                      :desabilitarInput="desabilitado"
                      idModal="modalCliente"
                      :classe-required="true"
                      label="Fornecedor"
                      place="Informe o Fornecedor"
                      labelBotao=""
                      :arredondado="true">
                    </cliente-pesquisa>
                  </div>
                  <div class="col-sm-6 mb-3">
                    <b-form-group label="Grupo de Documentos" label-class="font-weight-bold text-muted small text-uppercase">
                      <grupo-apagar-drop-down 
                        v-model="registro.COD_GRUPO"
                        :state="!!registro.COD_GRUPO"
                        placeholder="Selecione o Grupo"
                        input-class="rounded-pill shadow-xs">
                      </grupo-apagar-drop-down>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 mb-3">
                    <b-form-group label="Histórico do Plano de Contas" label-class="font-weight-bold text-muted small text-uppercase">
                      <historico-caixa-dropdown 
                        v-model="registro.HISTORICO_ID"
                        :state="!!registro.HISTORICO_ID"
                        tipo="DEBITO"
                        placeholder="Selecione o Histórico"
                        input-class="rounded-pill shadow-xs">
                      </historico-caixa-dropdown>
                    </b-form-group>
                  </div>
                  <div class="col-sm-6 mb-3">
                    <b-form-group label="Centro de Custo" label-class="font-weight-bold text-muted small text-uppercase">
                      <centro-custo-drop-down 
                        v-model="registro.ID_CENTRO_CUSTO"
                        :state="!!registro.ID_CENTRO_CUSTO"
                        placeholder="Selecione o Centro de Custo"
                        input-class="rounded-pill shadow-xs">
                      </centro-custo-drop-down>
                    </b-form-group>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>  

          <b-col sm="12">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex align-items-center justify-content-between">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-balance-scale mr-2"></i>Ajustes - Juros e Descontos
                </h5>
                <b-button variant="success" size="sm" pill class="px-3 shadow-sm" @click="abrirModalAjusteAdd()">
                  <i class="fa fa-plus mr-1"></i> Adicionar
                </b-button>
              </div>
              <b-card-body class="pt-0">
                <b-table 
                  striped 
                  hover 
                  show-empty
                  responsive
                  bordered
                  small
                  class="rounded shadow-sm overflow-hidden"
                  :dark="isDark"
                  head-variant="light"
                  empty-text="Não existe ajuste"
                  :items="ajustes.items" 
                  :fields="ajustes.fields"
                  @row-dblclicked="abrirModalAjusteEdit"
                >
                  <template #cell(OP_TIPO)="item">
                    <b-badge pill :variant="colorirAjusteOP_TIPO(item.item.OP_TIPO)">{{traduzirAjusteOP_TIPO(item.item.OP_TIPO)}}</b-badge>
                  </template>      
                  <template #cell(actions)="item">
                    <div class="text-center">
                      <b-button type="button" @click="deleteAjustes(item.item)" size="sm" variant="soft-danger" pill class="btn-action-pill" v-b-tooltip.hover="'Remover Ajuste'">
                        <i class="fa fa-trash-o"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="12" v-if="!registro.SEQUENCIA">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-calculator mr-2"></i>Valores e Parcelamento
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-overlay :show="parcelamentoParametros.busy" rounded="lg" opacity="0.6" @hidden="onHidden_botaoParcelamento()">
                  <b-row>
                    <b-col sm="3">
                      <b-form-group label="Valor do Título R$" label-class="font-weight-bold text-muted small text-uppercase">
                        <vue-autonumeric v-model="parcelamentoParametros.valor" :options="'Brazilian'" id="ob_edValor" :class="['form-control rounded-pill shadow-xs', {'is-invalid': !parcelamentoParametros.valor && parcelamentoParametros.submmited}]"></vue-autonumeric>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label="Parcelado em X(vezes)" label-class="font-weight-bold text-muted small text-uppercase">
                        <b-form-select :plain="true" id="ob_comboVezes" class="rounded-pill custom-select shadow-xs" v-model="parcelamentoParametros.vez" :options="parcelamentoParametros.vezes" :class="{'is-invalid': !parcelamentoParametros.vez && parcelamentoParametros.submmited}"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label="Data Primeiro Vencimento" label-class="font-weight-bold text-muted small text-uppercase">
                        <b-form-input type="date" id="ob_edPrimeiroVencimento" class="rounded-pill shadow-xs" v-model="parcelamentoParametros.dataPrimeira" :class="{'is-invalid': !parcelamentoParametros.dataPrimeira && parcelamentoParametros.submmited}"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label="Dias entre as Parcelas" label-class="font-weight-bold text-muted small text-uppercase">
                        <b-input-group>
                          <b-form-select :plain="true" class="rounded-pill-left custom-select shadow-xs" v-model="parcelamentoParametros.dia" :options="parcelamentoParametros.dias" :disabled="parcelamentoParametros.busy"></b-form-select>  
                          <b-input-group-append>
                            <b-button ref="bt_gerarParcelamento" :disabled="parcelamentoParametros.busy" variant="primary" class="rounded-pill-right shadow-xs px-3" @click="onClick_botaoParcelamento()">
                              <i class="fa fa-refresh mr-1"></i> Gerar
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="mt-3">
                    <b-table 
                      striped 
                      hover 
                      show-empty
                      responsive
                      bordered
                      small
                      class="rounded shadow-sm overflow-hidden"
                      :dark="isDark"
                      head-variant="light"
                      empty-text="Não existe parcelamento"
                      :items="tabelaParcelamento.items" 
                      :fields="tabelaParcelamento.fields"
                      :tbody-tr-class="rowClassSelecionadoParcela"
                      @row-clicked="clicarLinhaParcela"
                      @row-dblclicked="abrirModalVencimento"
                    >
                      <template #cell(vencimento)="item">
                        {{ converterDataVencimento(item.item.vencimento) }}
                      </template>      
                    </b-table>
                  </div>
                </b-overlay>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col sm="12" v-else>
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex align-items-center justify-content-between">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-line-chart mr-2"></i>Valores e Acompanhamento
                </h5>
                <b-button variant="outline-primary" size="sm" pill class="px-3 shadow-sm" @click="abrirModalPagamentos()">
                  <i class="fa fa-money mr-1"></i> Visualizar Pagamentos
                </b-button>
              </div>
              <b-card-body class="pt-0">
                <div class="row">
                  <div class="col-sm-3">
                    <b-form-group label="Valor Original R$" label-class="font-weight-bold text-muted small text-uppercase">
                      <vue-autonumeric v-model="registro.VL_DOC" :options="'Brazilian'" disabled class="form-control text-right rounded-pill bg-light border-0 shadow-xs"></vue-autonumeric>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Pagamentos" label-class="font-weight-bold text-muted small text-uppercase">
                      <b-form-input class="text-right rounded-pill bg-light border-0 shadow-xs" v-model="pagamentos.somaTotalPago" disabled></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Ajustes R$" label-class="font-weight-bold text-muted small text-uppercase">
                      <vue-autonumeric v-model="registro.VL_MULTA" :options="'Brazilian'" disabled class="form-control text-right rounded-pill bg-light border-0 shadow-xs"></vue-autonumeric>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Valor em Aberto R$" label-class="font-weight-bold text-muted small text-uppercase">
                      <vue-autonumeric v-model="registro.VL_APAGAR" :options="'Brazilian'" disabled class="form-control text-right rounded-pill bg-light border-0 shadow-xs"></vue-autonumeric>
                    </b-form-group>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col sm="12" v-if="registro.SEQUENCIA">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-history mr-2"></i>Auditoria
                </h5>
              </div>
              <b-card-body class="pt-0">
                <div class="row">
                  <div class="col-sm-3">
                    <b-form-group label="Cadastrado por" label-class="font-weight-bold text-muted small text-uppercase">
                      <b-form-input class="rounded-pill bg-light border-0 shadow-xs" :value="registro.USUARIO_CADASTRO || '-'" disabled></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Data cadastro" label-class="font-weight-bold text-muted small text-uppercase">
                      <b-form-input class="rounded-pill bg-light border-0 shadow-xs" :value="formatarDataAuditoria(registro.DATA_CADASTRO)" disabled></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Alterado por" label-class="font-weight-bold text-muted small text-uppercase">
                      <b-form-input class="rounded-pill bg-light border-0 shadow-xs" :value="registro.USUARIO_ALTERACAO || '-'" disabled></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Data alteracao" label-class="font-weight-bold text-muted small text-uppercase">
                      <b-form-input class="rounded-pill bg-light border-0 shadow-xs" :value="formatarDataAuditoria(registro.DATA_ALTERACAO)" disabled></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- MODAL VENCIMENTO -->
    <b-modal ref="modal-parcela" 
            id="modal-parcela" 
            size="md"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @shown="focusModalParcela()" 
            header-class="modal-header-premium"
            body-class="p-4"
            footer-class="border-top-0 p-3"
            title="ALTERAR PARCELA">
            
      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <div class="header-icon-wrapper-modal mr-3">
              <i class="fa fa-pencil-square-o text-white"></i>
            </div>
            <div>
              <h5 class="modal-title text-white mb-0">Alterar Parcela</h5>
              <small class="text-white-50">Ajuste data e valor da parcela</small>
            </div>
          </div>
        </div>
      </template>
            
      <b-row class="mb-3">
        <b-col sm="12">
          <b-form-group label="Data de Vencimento" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-input type="date" id="edParcelamentoVENCIMENTO" ref="edParcelamentoVENCIMENTO" class="rounded-pill shadow-xs" v-model="tabelaParcelamento.item.vencimento" :state="!!tabelaParcelamento.item.vencimento"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group label="Valor da Parcela" label-class="font-weight-bold text-muted small text-uppercase">
            <vue-autonumeric v-model="tabelaParcelamento.item.valor" :options="'Brazilian'" id="edParcelamentoVALOR" ref="edParcelamentoVALOR" :class="['form-control rounded-pill shadow-xs', {'is-invalid': !tabelaParcelamento.item.valor, 'is-valid': !!tabelaParcelamento.item.valor}]"></vue-autonumeric>
          </b-form-group>
        </b-col>
      </b-row>
    
      <template #modal-footer="{ cancel }">
        <b-button variant="soft-danger" class="rounded-pill px-4" @click="cancel()">
          <i class="fa fa-times mr-1"></i> Cancelar
        </b-button>
        <b-button variant="success" class="rounded-pill px-4" @click="editParcela(tabelaParcelamento.item)">
          <i class="fa fa-check mr-1"></i> Confirmar
        </b-button>
      </template>
    </b-modal>

    <!-- MODAL AJUSTE -->
    <b-modal ref="modal-ajuste" 
            id="modal-ajuste" 
            size="lg"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @shown="focusModalAjuste()" 
            header-class="modal-header-premium"
            body-class="p-4"
            footer-class="border-top-0 p-3"
            title="AJUSTES DE VALORES DO TITULO">

      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <div class="header-icon-wrapper-modal mr-3">
              <i class="fa fa-balance-scale text-white"></i>
            </div>
            <div>
              <h5 class="modal-title text-white mb-0">Ajustes de Valores</h5>
              <small class="text-white-50">Lançamento de juros, multas ou descontos</small>
            </div>
          </div>
        </div>
      </template>

      <div class="bg-light rounded-lg p-3 mb-4 border shadow-xs">
        <b-row class="mb-2">
          <b-col sm="3" class="text-muted small font-weight-bold text-uppercase">Fornecedor:</b-col>
          <b-col sm="9" class="font-weight-bold text-primary">{{ajustes.nomeFornecedor}}</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-muted small font-weight-bold text-uppercase">Documento:</b-col>
          <b-col sm="9" class="font-weight-bold">{{registro.DOCUMENTO}} - {{registro.PARCELA}}</b-col>
        </b-row>
        <b-row>
          <b-col sm="3" class="text-muted small font-weight-bold text-uppercase">Valor Atual:</b-col>
          <b-col sm="6" class="font-weight-bold text-success">R$ {{ (registro.VL_APAGAR || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</b-col>
          <b-col sm="3" class="text-right">
            <b-badge pill :variant="colorirTipoMovimentacao(ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID)">{{traduzirTipoMovimentacao(ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID)}}</b-badge>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col sm="4">
          <b-form-group label="Valor" label-class="font-weight-bold text-muted small text-uppercase">
            <vue-autonumeric v-model="ajustes.registro.VALOR" :options="'Brazilian'" id="edAjustesVALOR" ref="edAjustesVALOR" :class="['form-control rounded-pill shadow-xs', {'is-invalid': !ajustes.registro.VALOR, 'is-valid': !!ajustes.registro.VALOR}]"></vue-autonumeric>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Tipo de Movimentação" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-select v-model="ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID" ref="edTipoMovimentacao" :options="ajustes.tipoMovimentacoes.options" :state="!!ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID" class="rounded-pill custom-select shadow-xs"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Data" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-input type="date" id="edAjustesDATA" :state="!!ajustes.registro.DATA" v-model="ajustes.registro.DATA" class="rounded-pill shadow-xs"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-form-group label="Descrição" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-input type="text" id="edAjustesDESCRICAO" :state="!!ajustes.registro.DESCRICAO" placeholder="Informe a Descricao" v-model="ajustes.registro.DESCRICAO" class="rounded-pill shadow-xs"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-form-group label="Observação" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-textarea id="edAjustesOBSERVACAO" v-model="ajustes.registro.OBSERVACAO" placeholder="Opcional..." rows="3" class="rounded-lg shadow-xs"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">
        <b-button variant="soft-danger" class="rounded-pill px-4" @click="cancel()">
          <i class="fa fa-times mr-1"></i> Cancelar
        </b-button>
        <b-button variant="success" class="rounded-pill px-4" @click="postAjustes()">
          <i class="fa fa-save mr-1"></i> Gravar Ajuste
        </b-button>
      </template>
    </b-modal>

    <!-- MODAL PAGAMENTOS -->
    <b-modal ref="modal-pagamentos" 
            id="modal-pagamento" 
            size="lg"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            header-class="modal-header-premium"
            body-class="p-4"
            footer-class="border-top-0 p-3"
            title="VISUALIZAR PAGAMENTOS">

      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <div class="header-icon-wrapper-modal mr-3">
              <i class="fa fa-money text-white"></i>
            </div>
            <div>
              <h5 class="modal-title text-white mb-0">Histórico de Pagamentos</h5>
              <small class="text-white-50">Relação de baixas efetuadas para este título</small>
            </div>
          </div>
        </div>
      </template>

      <b-table 
        striped 
        hover 
        show-empty
        responsive
        bordered
        small
        class="rounded shadow-sm overflow-hidden"
        :dark="isDark"
        head-variant="light"
        empty-text="Nenhum pagamento encontrado"
        :items="pagamentos.items" 
        :fields="pagamentos.fields"
      >
        <template #foot(VL_PAGO)="">
          <span class="font-weight-bold text-success">{{pagamentos.somaTotalPago}}</span>
        </template>
      </b-table>

      <template #modal-footer="{ cancel }">
        <b-button variant="soft-danger" class="rounded-pill px-4" @click="cancel()">
          <i class="fa fa-times mr-1"></i> Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import GrupoApagarDropDown from '../../componentes/dropdown/GrupoApagarDropDown.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import HistoricoCaixaDropdown from '../../componentes/dropdown/HistoricoCaixaDropdown.vue'
import CentroCustoDropDown from '../../componentes/dropdown/CentroCustoDropDown.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'

export default {
  data () {
    return {
      formok: true,
      isLoading: false,
      status: '',
      pagamentos: {
        isBusy: false,
        somaTotalPago: 0,
        currentPage: 1,
        perPage: 10,
        items: [],
        fields: [
          {
            key: "DT_BAIXA",
            label: 'Data', 
            formatter: (value, key, item) => 
              moment(String(value)).format('DD/MM/YYYY')
          },
          {
            key: "USUARIO",
            label: 'Usuário',
          },
          {
            key: 'VL_PAGO', 
            class:'text-right', 
            label: 'Valor Pago', 
            formatter: (value, key, item) => 
              value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
      },
      parcelamentoParametros: {
        submmited: false,
        value: 'Some value',
        busy: false,
        timeout: null,
        clicou: false,
        valor: 0.00,
        vez: 1,
        vezes: [],
        dia: 1,
        dias: [],
        ob_edValor: false,
        ob_edVezes: true,
        ob_edDias: true,
        dataPrimeira: new Date().toISOString().slice(0, 10)
      },
      gerarDocumentoParametros: {
        submmited: false,
        value: 'Some value',
        busy: false,
        clicou: false
      },
      tipoOptions: [
        { value: '0', text: 'Título' },
        { value: '1', text: 'Duplicata' },
        { value: '2', text: 'Boleto' },
        { value: '3', text: 'Promissória' },
        { value: '4', text: 'Cheque' },
        { value: '5', text: 'Outros' },
      ],
      tabelaParcelamento: {
        fields: [
          {
            key: "parcela",
            label: 'Parcela'
          },
          {
            key: 'vencimento',
            label: 'Vencimento',
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },
          {
            key: 'valor', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
        items: [],
        parcelaSelecionada: null,
        itemSelecionado: {},
        item: {
          documento: null,
          observacao: null,
          vencimento: null,
          parcela: null,
          valor: null,
        }
      },
      ajustes: {
        nomeFornecedor: '',
        tipoTraduzido: '',
        fields: [
          {
            key: "ID",
            label: 'ID'
          },
          {
            key: 'DESCRICAO',
            label: 'Descrição'
          },
          {
            key: 'OP_TIPO',
            label: 'Tipo'
          },
          {
            key: 'DATA',
            class:'text-right', 
            label: 'Data',
            formatter: (value, key, item) => 
              value = value ? moment(value).format("DD/MM/YYYY") : null
          },
          {
            key: 'VALOR', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-right p-0 align-middle',
            thStyle: { width: '10% !important'} 
          }
        ],
        items: [],
        registro: {
          ID                           : null,
          APAGAR_ID                    : null,
          OP_TIPO                      : null,
          VALOR                        : null,
          DESCRICAO                    : null,
          DATA                         : null,
          DATA_CADASTRO                : null,
          USUARIO_CADASTRO             : null,
          DATA_ALTERACAO               : null,
          USUARIO_ALTERACAO            : null,
          DATA_EXCLUSAO                : null,
          USUARIO_EXCLUSAO             : null,
          SITUACAO                     : null,
          OBSERVACAO                   : null,
          TIPO_MOVIMENTACAO_TITULO_ID  : null,
          DOCUMENTO                    : null,
          PARCELA                      : null,
          
        },

        tipoMovimentacoes: {
          options: [],
          items: []
        },

      },
      registro: {
          SEQUENCIA                       : null,
          DOCUMENTO                       : null,
          PARCELAS                        : null,
          DESCRICAO                       : null,
          DOCREAL                         : null,
          SEQ_ENT                         : null,
          ITENS                           : null,
          COD_CONTA                       : null,
          COD_FORNEC                      : null,
          COD_BANCO                       : null,
          COD_REPRES                      : null,
          GRUPO                           : null,
          DT_DOC                          : null,
          DT_LANCAMENTO                   : null,
          DT_VENC                         : null,
          FORMA                           : null,
          VL_DOC                          : null,
          VL_APAGAR                       : null,
          TIPO_COBRA                      : null,
          STATUS                          : null,
          VL_MULTA                        : null,
          DSC_MULTA                       : null,
          VL_DOCUMENTO_PRINCIPAL          : null,
          OP_TIPO                         : null,
          ID_EMPRESA                      : null,
          ID_CENTRO_CUSTO                 : null,
          COD_GRUPO                       : null,
          OP_ORIGEM                       : null,
          PEDIDO_COMPRA_DESPESA_ID        : null,
          EMBARQUE_REPRESENTA_DESPESA_ID  : null,
          VEICULO_ABASTECIMENTO_ID        : null,
          VEICULO_MANUTENCAO_ID           : null,
          CONTRATO_FLUXO_ID               : null,
          HISTORICO_ID                    : null,
          COMPRA_GADO_DESPESA_ID          : null,
          ABATE_ID                        : null,
          COMPRA_GADO_ID                  : null,
          USUARIO_CADASTRO                : null,
          USUARIO_ALTERACAO               : null,
          USUARIO_REPOSICAO               : null,
          DATA_CADASTRO                   : null,
          DATA_ALTERACAO                  : null,
          DATA_REPOSICAO                  : null,
          PEDIDO_COMPRA_ID                : null,
          OBSERVACAO                      : null,
          NOTA_FISCAL                     : null,
          NUMERO_EXTERNO                  : null,
          APAGAR_PAI_ID                   : null,
          
        },
         
      optionshistoricos: [],
      optionsGrupos: [],
      submmited: false
    }
  },
  components: {
    VueButtonSpinner,
    GrupoApagarDropDown,
    ClientePesquisa,
    HistoricoCaixaDropdown,
    CentroCustoDropDown,
    VueAutonumeric,
    HeaderPadrao
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },  
    desabilitado () {
      return this.registro.SEQUENCIA != null && this.registro.SEQUENCIA > 0
    },
    isValid() {
      return     !!this.registro.DOCUMENTO 
              && !!this.registro.OP_TIPO
              && !!this.registro.ITENS
              && !!this.registro.COD_FORNEC
              && !!this.registro.COD_GRUPO
              && !!this.registro.HISTORICO_ID
              && !!this.registro.ID_CENTRO_CUSTO
              && !!this.registro.NUMERO_EXTERNO
              && (this.registro.SEQUENCIA > 0 ? !!this.registro.DT_VENC : true)
    },
    tamanhocampoPagina () {
      if (this.registro.PAGINA) {
        return this.registro.PAGINA.length > 2 ? null : false
      }
      return false
    },
    statusClass() {
      const status = String(this.registro.STATUS || 'PENDENTE').trim().toUpperCase()
      if (status === 'PAGO' || status === 'QUITADO') return 'is-paid'
      if (this.registro.DT_VENC && moment(this.registro.DT_VENC).isBefore(moment(), 'day')) return 'is-late'
      return 'is-open'
    },
    diasParaVencer() {
      if (!this.registro.DT_VENC) return 'Vencimento nao informado'
      const dias = moment(this.registro.DT_VENC).startOf('day').diff(moment().startOf('day'), 'days')
      if (dias < 0) return `${Math.abs(dias)} dia(s) em atraso`
      if (dias === 0) return 'Vence hoje'
      return `Vence em ${dias} dia(s)`
    },
    diasParaVencerClass() {
      const status = String(this.registro.STATUS || 'PENDENTE').trim().toUpperCase()
      if (status === 'PAGO' || status === 'QUITADO') return 'text-success'
      if (!this.registro.DT_VENC) return 'text-muted'
      const dias = moment(this.registro.DT_VENC).startOf('day').diff(moment().startOf('day'), 'days')
      if (dias < 0) return 'text-danger'
      if (dias === 0) return 'text-warning font-weight-bold'
      return 'text-primary'
    },
    statusCardClass() {
      const status = String(this.registro.STATUS || 'PENDENTE').trim().toUpperCase()
      if (status === 'PAGO' || status === 'QUITADO') return 'bg-gradient-success'
      if (this.registro.DT_VENC && moment(this.registro.DT_VENC).isBefore(moment(), 'day')) return 'bg-gradient-danger'
      return 'bg-gradient-info'
    },
    statusIconClass() {
      const status = String(this.registro.STATUS || 'PENDENTE').trim().toUpperCase()
      if (status === 'PAGO' || status === 'QUITADO') return 'bg-icon-success'
      if (this.registro.DT_VENC && moment(this.registro.DT_VENC).isBefore(moment(), 'day')) return 'bg-icon-danger'
      return 'bg-icon-info'
    },
    statusIcon() {
      const status = String(this.registro.STATUS || 'PENDENTE').trim().toUpperCase()
      if (status === 'PAGO' || status === 'QUITADO') return 'fa-check-circle'
      if (this.registro.DT_VENC && moment(this.registro.DT_VENC).isBefore(moment(), 'day')) return 'fa-exclamation-circle'
      return 'fa-hourglass-half'
    }
  },
  methods: {
    rowClassSelecionadoParcela(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.tabelaParcelamento.parcelaSelecionada
      return item.parcela === selId ? 'cec-row-selected' : ''
      
    },
    clicarLinhaParcela(item) {
      this.tabelaParcelamento.parcelaSelecionada = item.parcela
    },
    converterDataVencimento(data) {
      return Tools.formatarDataBR(data)
    },
    formatCurrency(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatarDataAuditoria(data) {
      return data ? Tools.formatarDataBR(data) : '-'
    },
    async somarPagamentos() {

      try {
        const {data} = await this.$http.get(`/api/protected/pago/listarpagamentostitulo?apagarId=${this.registro.SEQUENCIA}&documento=${this.registro.DOCUMENTO}&parcela=${this.registro.PARCELAS}` )
        
        this.pagamentos.items = data
        let total = 0
        if (Array.isArray(this.pagamentos.items)) {
          total = this.pagamentos.items.reduce((valor, item) => {
            return valor + (parseFloat(item.VL_PAGO) || 0)
          }, 0)
        }
        this.pagamentos.somaTotalPago = total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        
        
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Valor da Parcela inválido` )
      }

      
    },
    
    async abrirModalPagamentos() {
      this.$store.commit('controle/setAguardando', true)

      try {
        await this.somarPagamentos()
        this.$refs['modal-pagamentos'].show()
        
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Valor da Parcela inválido` )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      
    },
    abrirModalVencimento(item) {
      this.tabelaParcelamento.item = Tools.resetToNull(this.tabelaParcelamento.item, true)
      this.tabelaParcelamento.item = JSON.parse(JSON.stringify(item)) // deep clone
      this.tabelaParcelamento.itemSelecionado = item //usado para devolver os valores editados
      this.tabelaParcelamento.item.vencimento = Tools.formatarDataParaInput(this.tabelaParcelamento.item.vencimento)
      this.$refs['modal-parcela'].show()      
    },
    async editParcela() {
      if (!this.tabelaParcelamento.item.valor || this.tabelaParcelamento.item.valor <= 0) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Valor da Parcela inválido` )
        return 
      }
      if (!this.tabelaParcelamento.item.vencimento ) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Informe o vencimento` )
        return 
      }
      try {

        this.tabelaParcelamento.itemSelecionado.valor = this.tabelaParcelamento.item.valor
        this.tabelaParcelamento.itemSelecionado.vencimento = this.tabelaParcelamento.item.vencimento

        const soma = this.tabelaParcelamento.items.reduce((total, item) => {
          return total + (item.valor ?? 0) // usa 0 caso valor seja null/undefined
        }, 0)

        this.parcelamentoParametros.valor = soma
        
      } finally {
        this.$refs['modal-parcela'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalParcela() {
      this.$refs.edParcelamentoVENCIMENTO.focus()
    },
    
    voltar() {
      this.$router.push('/movimentos/contasapagar/listagem')
    },
    async carregarAjustes() {
      try {
        const {data}  = await this.$http.get('/api/protected/apagarAjuste/getByApagarId/' + this.registro.SEQUENCIA)
        this.ajustes.items = data
      } catch(err) {
        console.log(err)  
        throw err
      }
    },
    async carregarTiposMovimentacao() {
      try {
        const {data}  = await this.$http.get('/api/protected/tipoMovimentacaoApagar/listarTodos')
        this.ajustes.tipoMovimentacoes.options = [{value: null, text: ''}]
        this.ajustes.tipoMovimentacoes.items = data
        for (const und of data ) {
          this.ajustes.tipoMovimentacoes.options.push({value: und.ID, text: `${und.ID} - ${und.DESCRICAO}`})
        }
      } catch(err) {
        console.log(err)  
        throw err
      }
    },
    async abrirModalAjusteAdd() {
      if (!this.registro.SEQUENCIA || this.registro.SEQUENCIA == null) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `É necessário gravar o título antes de lançar Ajustes` )
        return
      }
      try{
        await this.carregarTiposMovimentacao()
        this.ajustes.nomeFornecedor = this.$refs.edCOD_FORNEC?.$refs?.auto?.$refs?.autocomplete._value || ''

        Tools.resetToNull(this.ajustes.registro, true)
        
        this.ajustes.registro.APAGAR_ID = this.registro.SEQUENCIA
        this.ajustes.registro.DOCUMENTO = this.registro.DOCUMENTO
        this.ajustes.registro.PARCELA = this.registro.PARCELAS
        this.ajustes.registro.DATA = Tools.getDataAtual()
        this.$refs['modal-ajuste'].show()
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possivel carregar a movimentação! ${err}` )
        return
      }
    },
    async abrirModalAjusteEdit(item) {
      if ((item.ID == null) || (item.ID <= 0)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Selecione um registro!!!` )
        return
      }
      try {  
        this.$store.commit('controle/setAguardando', true)
        await this.carregarTiposMovimentacao()
        this.ajustes.nomeFornecedor = this.$refs.edCOD_FORNEC?.$refs?.auto?.$refs?.autocomplete._value || ''
        const {data} = await this.$http.get(`/api/protected/apagarAjuste/getById/${item.ID}`)
        if (!data || data.length <= 0 ) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Registro não localizado!!!` )
          return
        }
        this.ajustes.registro = data[0]
        this.ajustes.registro.DATA = Tools.formatarDataParaInput(this.ajustes.registro.DATA)
        this.$refs['modal-ajuste'].show()
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possivel carregar a movimentação! ${err}` )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async postAjustes() {
      if ( !this.ajustes.registro.VALOR || this.ajustes.registro.VALOR <= 0 ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Valor da Movimentação!!!` )
        return
      }
      if ( !this.ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe o Tipo da Movimentação!!!` )
        return
      }
      if ( !this.ajustes.registro.DESCRICAO || this.ajustes.registro.DESCRICAO.length < 3 ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe a Descrição da Movimentação com no mínimo 3 letras!!!` )
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadAjustes = {
          login: window.localStorage.getItem('login'),
          registro: this.ajustes.registro
        }
        if (this.ajustes.registro.ID) {
          const {data} = await this.$http.put('/api/protected/apagarAjuste/edit', payloadAjustes)
          this.ajustes.items = data.ajustes
          this.registro = data.apagar[0]
          this.ajustarDados()
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Movimentação alterada com sucesso!!!` )
        } else {
          const {data} = await this.$http.post('/api/protected/apagarAjuste/post', payloadAjustes)
          this.ajustes.items = data.ajustes
          this.registro = data.apagar[0]
          this.ajustarDados()
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Movimentação cadastrada com sucesso!!!` )
        }
        this.$refs['modal-ajuste'].hide()
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possivel gravar a movimentação! ${err.message || err}` )
        return
      }
      finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteAjustes(item) {
      const msg = await this.$bvModal.msgBoxConfirm('Remover o ajuste lançado??', {
        title: 'Remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      if ( !item.ID || item.ID == null ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Nenhum registro selecionado!!!` )
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadAjustes = {
          login: window.localStorage.getItem('login'),
          id: item.ID,
          documento: this.registro.DOCUMENTO,
          parcela: this.registro.PARCELAS
        }
        const {data} = await this.$http.post('/api/protected/apagarAjuste/delete', payloadAjustes)
        this.ajustes.items = data.ajustes
        this.registro = data.apagar
        this.ajustarDados()
        
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Movimentação removida com sucesso!!!` )
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possivel gravar a movimentação! ${err.message || err}` )
        return
      }
      finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalAjuste() {
      this.$nextTick(() => {
        this.$refs.edAjustesVALOR.$el.focus()
        this.$refs.edAjustesVALOR.$el.select()
      })
    },
    onHidden_botaoParcelamento() {
      // Return focus to the button
      this.$refs.bt_gerarParcelamento.focus()
    },
    onClick_botaoParcelamento() {
      this.parcelamentoParametros.submmited = true
      this.parcelamentoParametros.busy = true
      this.gerarParcelamento()
    },
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      this.$refs.bt_gerarDocumento.focus()
    },
    onClick_botaoGerarDocumento() {
      this.gerarDocumentoParametros.submmited = true
      this.gerarDocumentoParametros.busy = true

      let uri = `/api/protected/apagar/getnovonumerodocumento`
      this.$http.get(uri)
      .then((data) => {
        this.registro.DOCUMENTO = data.data
        this.gerarDocumentoParametros.busy = false
      })
    },
    post () {
      if ( !this.registro.SEQUENCIA || this.registro.SEQUENCIA === null || this.registro.SEQUENCIA === undefined ) {
        this.novo()
      } else {
        this.editar()
      }
    },
    async novo () {
      if (!this.isValid) {
        Tools.exibirMensagem(this.$store, 'Obrigatórios', 'warning', 'Preencha todos os campos obrigatórios!!!')
        return
      }
      if (!this.tabelaParcelamento.items || !this.tabelaParcelamento.length <= 0 ) {
        Tools.exibirMensagem(this.$store, 'Obrigatórios', 'warning', 'Informe o Lançamento das Parcelas. Mesmo se for apenas UMA!!!')
        return
      }
    
      if (this.registro.SEQUENCIA) {
        Tools.exibirMensagem(this.$store, 'Obrigatórios', 'warning', 'Operação não permitida. O Título já esta salvo!!!')
        return
      }
      
      let pacote = {
        registro : this.registro,
        parcelamento : this.tabelaParcelamento.items,
        login: window.localStorage.getItem('login')
      }
          
      try {
        this.$store.commit('controle/setAguardando', true)
        
        let {data} = await this.$http.post(`/api/protected/apagar/post`, pacote)
        const novoID = data.id
        this.$store.commit("apagar/SET_LIMPAR_APENAS_FILTRO", null)
        this.$store.commit("apagar/SET_REGISTRO_SELECIONADO_ID", novoID)
        this.$store.commit("apagar/SET_DOCUMENTO", this.registro.DOCUMENTO)
        await this.$store.dispatch('apagar/GERAR_LISTA')
        this.$store.commit("apagar/SET_DOCUMENTO", null)

        this.$router.push(`/movimentos/contasapagar/listagem`)
      
      }  catch(err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err )
      } finally {
        this.$store.commit('controle/setAguardando', false)

      } 
    },
    async editar() {
      if (!this.isValid) {
        Tools.exibirMensagem(this.$store, 'Obrigatórios', 'warning', 'Preencha todos os campos obrigatórios!!!')
        return
      }
     
      if (!this.registro.SEQUENCIA) {
        Tools.exibirMensagem(this.$store, 'Obrigatórios', 'warning', 'Operação não permitida. O Título não pode ser alterado sem ID!!!')
        return
      }
      
      let pacote = {
        registro : this.registro,
        login: window.localStorage.getItem('login')
      }
          
      try {
        this.$store.commit('controle/setAguardando', true)
        
        let {data} = await this.$http.post(`/api/protected/apagar/edit`, pacote)
        this.$store.commit("apagar/SET_LIMPAR_APENAS_FILTRO", null)
        this.$store.commit("apagar/SET_REGISTRO_SELECIONADO_ID", this.registro.SEQUENCIA)
        this.$store.commit("apagar/SET_DOCUMENTO", this.registro.DOCUMENTO)
        await this.$store.dispatch('apagar/GERAR_LISTA')
        this.$store.commit("apagar/SET_DOCUMENTO", null)

        this.$router.push(`/movimentos/contasapagar/listagem`)
      
      }  catch(err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err )
      } finally {
        this.$store.commit('controle/setAguardando', false)

      } 
    },
    limparRegistro () {
      Tools.resetToNull(this.registro, true)
      this.registro.DESCRICAO = 'DOCUMENTOS'
      this.registro.DT_DOC = this.getDataHoje()
      this.registro.DT_LANCAMENTO = this.getDataHoje()
      this.registro.DT_VENC = this.getDataHoje()
      this.registro.OP_TIPO = '0'

      this.parcelamentoParametros.submmited = false
      this.parcelamentoParametros.value = 'Some value'
      this.parcelamentoParametros.busy = false
      this.parcelamentoParametros.timeout = null
      this.parcelamentoParametros.clicou = false
      this.parcelamentoParametros.valor = 0.00
      this.parcelamentoParametros.vez = 1
      this.parcelamentoParametros.dia = 0
      this.parcelamentoParametros.dataPrimeira = this.getDataHoje()
      this.parcelamentoParametros.ob_edValor = false
      this.parcelamentoParametros.ob_edVezes = true
      this.parcelamentoParametros.ob_edDias = true
    },
    iniciarFormNovo () {
      this.limparRegistro()
      this.pagamentos.somaTotalPago = 0.00
    },
    ajustarDados() {
      this.registro.DT_DOC = Tools.formatarDataParaInput(this.registro.DT_DOC)
      this.registro.DT_LANCAMENTO = Tools.formatarDataParaInput(this.registro.DT_LANCAMENTO)
      this.registro.DT_VENC = Tools.formatarDataParaInput(this.registro.DT_VENC)

      this.registro.OP_TIPO = this.registro.OP_TIPO.trim()
    },
    async iniciarFormEditar ( id ) {
      try {
        
        this.limparRegistro()

        const {data} = await this.$http.get(`/api/protected/apagar/getById/${id}`)
        if (!data || data.length <= 0) {
          throw new Error('Registro não encontrado!')
        }
        
        this.registro = data[0]
        this.ajustarDados()
        
        const carregamentos = [
          this.carregarAjustes()
          ,this.somarPagamentos()]
        await Promise.all(carregamentos)

      } catch (error) {
        console.log('Erro no iniciarFormEditar do ApagarCadastro')
        console.log(error)
        throw error  
      }
    },
    arredondar(valor) {
      return Number(valor.toFixed(2))
    },
    somarMeses(data, meses) {
      const d = new Date(data.getTime())
      const diaOriginal = d.getDate()
      d.setMonth(d.getMonth() + meses)

      // Corrige casos como 31 de janeiro + 1 mês => 3 de março
      if (d.getDate() < diaOriginal) {
        d.setDate(0) // vai para o último dia do mês anterior
      }

      return d
    },
    gerarParcelamento() {
        const parcelasInt = Math.round(this.parcelamentoParametros.vez)

        // Corrigir a data de entrada
        const baseData = new Date(`${this.parcelamentoParametros.dataPrimeira}T00:00:00`) // evita problemas de fuso
        
        const valorBase = this.arredondar(this.parcelamentoParametros.valor / parcelasInt)
        const totalBase = this.arredondar(valorBase * parcelasInt)
        const diferenca = this.arredondar(this.parcelamentoParametros.valor - totalBase) // pode ser centavos negativos

        this.tabelaParcelamento.items = []

        for (let i = 1; i <= parcelasInt; i++) {
          const vencimento = this.somarMeses(baseData, i)

          let valor = valorBase

          if (i === 1) {
            valor = this.arredondar(valorBase + diferenca) // soma o resto à primeira parcela
          }

          this.tabelaParcelamento.items.push({
            documento: '',
            vencimento: vencimento.toISOString().slice(0, 10), // data ISO
            parcela: i,
            valor: valor

          })
        }
        this.parcelamentoParametros.busy = false
    },
    prepararAuxiliares () {
      this.parcelamentoParametros.vezes = []
      for (let i = 1; i <= 60; i++) {
        this.parcelamentoParametros.vezes.push({value: i, text: i })
      }
      this.parcelamentoParametros.dias = []
      this.parcelamentoParametros.dias.push({
          value: 0,
          text: '0 Dias - Hoje'
      })
      for (let ii = 1; ii <= 60; ii++) {
        this.parcelamentoParametros.dias.push({
          value: ii,
          text: ii  + ' Dias'
        })
        
      }
    },
    colorirTipoMovimentacao(tipoMovimentacaoId) {
      const tp = this.ajustes.tipoMovimentacoes.items.find(item => item.ID === tipoMovimentacaoId) || ''
      const opTipo = tp.OP_TIPO
      if (opTipo === 'R') return 'danger'
      else if (opTipo === 'A') return 'success'
      else return 'secondary'
    },
    traduzirTipoMovimentacao(tipoMovimentacaoId) {
      const tp = this.ajustes.tipoMovimentacoes.items.find(item => item.ID === tipoMovimentacaoId) || ''
      const opTipo = tp.OP_TIPO
      if (opTipo === 'R') return 'RETIRAR'
      else if (opTipo === 'A') return 'ACRESCENTAR'
      else return 'INDISPONIVEL'
    },
    colorirAjusteOP_TIPO(opTipo) {
      if (opTipo === 'R') return 'danger'
      else if (opTipo === 'A') return 'success'
      else return 'secondary'
    },
    traduzirAjusteOP_TIPO(opTipo) {
      if (opTipo === 'R') return 'RETIRAR'
      else if (opTipo === 'A') return 'ACRESCENTAR'
      else return 'INDISPONIVEL'
    },
    getDataHoje() {
      const hoje = new Date()
      const ano = hoje.getFullYear()
      const mes = String(hoje.getMonth() + 1).padStart(2, '0')
      const dia = String(hoje.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}`
    }
  },
  async created () {
    let id = this.$route.params.id
    this.prepararAuxiliares()
    try {
      if ( id ) {
        await this.iniciarFormEditar( id )
      } else {
        await this.iniciarFormNovo()
      }
    } catch (error) {
      console.log('Erro no created do ApagarCadastro')
      console.log(error)
      Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possivel carregar o registro! ${error}` )
      this.formok = false
    }
  },
  watch: {
  }
}
</script>
<style scoped>
.apagar-cadastro-page {
  min-height: calc(100vh - 90px);
  background: #eef2f7;
  padding-bottom: 1rem;
}

.cadastro-scroll {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.bg-gradient-danger {
  border-top: 3px solid #ef4444;
}

.bg-icon-success {
  background-color: #d1fae5 !important;
  color: #059669 !important;
}

.bg-icon-danger {
  background-color: #fee2e2 !important;
  color: #dc2626 !important;
}

.bg-icon-info {
  background-color: #e0f2fe !important;
  color: #0284c7 !important;
}

.badge-light-opacity {
  background-color: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-weight: 600;
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 0.75rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 900;
  text-transform: uppercase;
  color: #fff;
}

.status-chip.is-open { background: #0ea5e9; }
.status-chip.is-late { background: #ef4444; }
.status-chip.is-paid { background: #10b981; }

.summary-grid {
  margin-left: -7px;
  margin-right: -7px;
}

.summary-grid > [class*="col-"] {
  padding-left: 7px;
  padding-right: 7px;
}

.apagar-cadastro-page .card {
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06) !important;
  overflow: hidden;
}

.apagar-cadastro-page .card-header {
  padding: 1rem 1.25rem !important;
  border-bottom: 1px solid #edf2f7 !important;
  background: #fff !important;
}

.apagar-cadastro-page .card-header h5 {
  margin: 0;
  color: #0f172a !important;
  font-size: 0.96rem;
  font-weight: 800;
}

.apagar-cadastro-page .card-header h5 i {
  color: #0891b2;
}

.apagar-cadastro-page .card-body {
  padding: 1.15rem 1.25rem 1.25rem;
}

.apagar-cadastro-page .form-group {
  margin-bottom: 0.9rem;
}

.apagar-cadastro-page .form-control,
.apagar-cadastro-page .custom-select {
  min-height: 38px;
  border-color: #dbe3ef;
}

.apagar-cadastro-page .form-control:focus,
.apagar-cadastro-page .custom-select:focus {
  border-color: #0891b2;
  box-shadow: 0 0 0 0.14rem rgba(8, 145, 178, 0.16) !important;
}

.summary-card {
  min-height: 112px;
  border-radius: 8px;
  padding: 1rem;
  color: #0f172a;
  background: #fff !important;
  border: 1px solid #e5e7eb;
  height: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.1) !important;
}

.summary-body {
  display: flex;
  align-items: center;
}

.summary-icon-wrapper {
  width: 45px;
  height: 45px;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-right: 15px;
}

.summary-content {
  flex: 1;
}

.summary-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #64748b;
  display: block;
  margin-bottom: 2px;
}

.summary-value {
  color: #0f172a;
  font-size: 1.08rem;
  font-weight: 800;
  margin-bottom: 0;
}

.bg-gradient-primary {
  border-top: 3px solid #2563eb;
}

.bg-gradient-success {
  border-top: 3px solid #10b981;
}

.bg-gradient-info {
  border-top: 3px solid #0891b2;
}

.bg-gradient-warning {
  border-top: 3px solid #f59e0b;
}

.shadow-xs {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.rounded-lg {
  border-radius: 1rem !important;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 50px;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-glass:hover {
  background: #28a745 !important;
  transform: translateY(-2px);
  color: white;
  box-shadow: 0 5px 15px rgba(40, 167, 69, 0.4);
}

.modal-header-premium {
  background: linear-gradient(135deg, #2c3e50 0%, #000000 100%);
  border-bottom: none;
  padding: 1.5rem;
}

.header-icon-wrapper-modal {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.btn-action-pill {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-action-pill:hover {
  transform: scale(1.1);
}

.variant-soft-danger {
  background-color: #fff5f5;
  color: #e53e3e;
  border: none;
}

.variant-soft-danger:hover {
  background-color: #fed7d7;
  color: #c53030;
}

.rounded-pill-left {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.rounded-pill-right {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}

.cec-row-selected {
  background-color: #e8f0fe !important;
  color: #1967d2 !important;
  font-weight: 600;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}

@media (max-width: 992px) {
  .summary-grid > [class*="col-"] {
    margin-bottom: 0.85rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/contasapagar/ApagarCadastro.vue